import { render, staticRenderFns } from "./AppNewMultiSelect.vue?vue&type=template&id=4568dd86&scoped=true"
import script from "./AppNewMultiSelect.vue?vue&type=script&lang=js"
export * from "./AppNewMultiSelect.vue?vue&type=script&lang=js"
import style0 from "./AppNewMultiSelect.vue?vue&type=style&index=0&id=4568dd86&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4568dd86",
  null
  
)

export default component.exports